// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"oWn1G","visible":"_2HPBd","tooltipWrapper":"_1GzHC"};